import Client from 'sharedreact/utils/Client';

function _isWinVersionSupported () {
  return (Client.isWindows7() || Client.isWindows8() || Client.isWindows81() || Client.isWindows10()) && Client.isWindows64();
}

function _isMacVersionSupported () {
  return (Client.isMacOSXElCapitan() || Client.isMacOSSierra() || Client.isMacOSHighSierra() || Client.isMacOSMojave() || Client.isMacOSCatalina() || Client.isMacOSBigSur());
}

function createDownloadUrl (application: string): string {
  const appSubPath: string = '/downloads/' + application + (Client.isMac() ? '.dmg' : '.exe');
  const path: string = window.location.href.replace(/.*:\/\/[^/]*/, '');

  // when accessing downloads from http(s)://<host>/workspaces/#/downloads => download path = http(s)://<host>/workspaces/downloads
  // else the path should be http(s)://<host>/downloads
  let downloadPath: string = '';
  if (path.startsWith('/#') || path.startsWith('/workspaces/#')) {
    downloadPath = window.location.href.replace(/\/#.*/, appSubPath);
  } else {
    downloadPath = window.location.href.replace(/\/[^/]*\/#.*/, appSubPath);
  }
  return downloadPath;
}

function isAllowedToDownload (): boolean {
  if (Client.isMac()) {
    return _isMacVersionSupported();
  } else if (Client.isWindows()) {
    return _isWinVersionSupported();
  }
  return false;
}

export default {
  createDownloadUrl,
  isAllowedToDownload
};
